import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { TeamTabs } from "@router/route-params";
import { useAppSelector } from "@store/store-helper";
import { assignableTeamsSelector } from "@store/teams/teams-selector";
import { TeamEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Custom hooks to have util functions for team */
export function useTeamUtils() {
  const $ = _c(13);
  const {
    trackEvent
  } = useTrackEvent();
  const {
    navigateToTeamDetails,
    navigateToTeamMembers
  } = useAppNavigation();
  const companyId = useCompanyId();
  const teams = useAppSelector(assignableTeamsSelector);
  let t0;
  if ($[0] !== teams) {
    t0 = function isTeamName(value) {
      return teams.some(team => team.name === value);
    };
    $[0] = teams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isTeamName = t0;
  let t1;
  if ($[2] !== teams) {
    t1 = function getTeamIdByName(teamName) {
      const team_1 = teams.find(team_0 => team_0.name === teamName);
      return team_1?.identity;
    };
    $[2] = teams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getTeamIdByName = t1;
  let t2;
  if ($[4] !== companyId || $[5] !== navigateToTeamDetails || $[6] !== navigateToTeamMembers || $[7] !== trackEvent) {
    t2 = function openTeamDetails(t3) {
      const {
        teamId,
        numberOfMembers,
        tab: t4
      } = t3;
      const tab = t4 === undefined ? TeamTabs.overview : t4;
      trackEvent({
        name: TeamEvents.openTeam,
        props: {
          teamId,
          numberOfMembers: numberOfMembers ?? ""
        }
      });
      if (tab === TeamTabs.members) {
        navigateToTeamMembers({
          companyId,
          teamId
        });
      } else {
        navigateToTeamDetails({
          companyId,
          teamId
        });
      }
    };
    $[4] = companyId;
    $[5] = navigateToTeamDetails;
    $[6] = navigateToTeamMembers;
    $[7] = trackEvent;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const openTeamDetails = t2;
  let t3;
  if ($[9] !== getTeamIdByName || $[10] !== isTeamName || $[11] !== openTeamDetails) {
    t3 = {
      openTeamDetails,
      isTeamName,
      getTeamIdByName
    };
    $[9] = getTeamIdByName;
    $[10] = isTeamName;
    $[11] = openTeamDetails;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}